/**
 * Main App component - using original Portugal Portuguese navigation
 */

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/layout/Navigation';
import { Footer } from './components/layout/Footer';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { WhatsAppButton } from './components/common/WhatsAppButton';
import { CookieConsent } from './components/common/CookieConsent';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { About } from './components/sections/About';
import { Services } from './components/sections/Services';
import { Advantages } from './components/sections/Advantages';
import { Portfolio } from './components/sections/Portfolio';
import { Testimonials } from './components/sections/Testimonials';
import { Contact } from './components/sections/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { NotFound } from './pages/NotFound';
import { useScrollOnLoad } from './hooks/useScrollOnLoad';
import navigationData from '@/data/navigation.json';

const navigationSections = navigationData.items;

function HomePage() {
  // Use scroll on load hook for home page
  useScrollOnLoad();

  return (
    <>
      <Hero />
      <Stats />
      <About />
      <Services />
      <Advantages />
      <Portfolio />
      <Testimonials />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div>
        <Navigation sections={navigationSections} />

        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
        <ScrollToTop />
        <WhatsAppButton />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
